import React, { createContext, useState, useCallback, useMemo, useContext } from 'react';
import baseHttpService from '../Services/baseHttp';

const ApiContext = createContext();

export const ApiProvider = ({ children }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const callApi = useCallback(async (method, url, payload = {}, params = {}, options = {}) => {
    setLoading(true);
    setError(null);
    try {
      let response;
      switch (method.toLowerCase()) {
        case 'get':
          response = await baseHttpService.getAll(url, params, options);
          break;
        case 'post':
          response = await baseHttpService.post(url, payload);
          break;
        case 'put':
          response = await baseHttpService.put(url, payload);
          break;
        case 'patch':
          response = await baseHttpService.patch(url, payload);
          break;
        case 'delete':
          response = await baseHttpService.delete(url);
          break;
        case 'fileupload':
          response = await baseHttpService.fileUpload(url, payload);
          break;
        default:
          throw new Error(`Unsupported method: ${method}`);
      }
      if (options.responseType !== 'blob') {
        setData(response);
      }
      return response;
    } catch (err) {
      setError(err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  const contextValue = useMemo(
    () => ({
      data,
      loading,
      error,
      callApi,
      setData,
    }),
    [data, loading, error, callApi]
  );

  return <ApiContext.Provider value={contextValue}>{children}</ApiContext.Provider>;
};

export const useApi = () => useContext(ApiContext);
